import { IdCard } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/components/ui/tooltip'
import { useVirtualBadgeStore } from '@/store'

// Acesso em 1 toque ao crachá virtual, fixo no header
export const VirtualBadgeButton = () => {
	const { t } = useTranslation()
	const open = useVirtualBadgeStore((s) => s.open)

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button
					aria-label={t('virtualBadge.title')}
					className="size-10 p-0 text-kaefer-silver hover:bg-white/10 hover:text-kaefer-silver md:size-8"
					onClick={open}
					size="icon"
					variant="ghost"
				>
					<IdCard className="size-5" />
				</Button>
			</TooltipTrigger>
			<TooltipContent>{t('virtualBadge.title')}</TooltipContent>
		</Tooltip>
	)
}
